<template>
    <div>
      <b-toast
        id="toast-check-modal-request-class"
        variant="none"
        no-close-button
        toaster="b-toaster-top-center"
		  >
		<img
			src="@/assets/img/ico-check.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
		<b-toast
		id="toast-equis-modal-request-class"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-equis.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
    <b-modal 
			:hide-footer="true" 
			:hide-header="true" 
			:centered="true" 
      modal-class="modal-schedule"
			id="modal-schedule" 
			size="xl"
      @hide="handleHideModal"
            
		>
      <!-- <div class="ea-alert mt-4">
        <icon name="alert-2" />
        <div class="content">
          <p>{{ $t("reusables.student-edited-schedule") }}</p>
        </div>
      </div> -->
      <!-- <template #modal-header="{ $bvModal }"> -->
        <img class="close" src="@/assets/img/close_red.png" @click="modalHideSchedule">
      <!-- </template> -->
			<b-row  v-if="showActions">
				<b-col>
					<div Class="card">
						<div class="perfil">
						 
						<b-avatar :src="dataStudent.photoStundet ?  dataStudent.photoStundet :  urlPhoto.PHOTO_STUDENT_DEFAULT"
             size="4rem" variant="light"></b-avatar>
							<div class="content">
								<h6>{{ dataStudent.className }}</h6>
                <label>{{$t('modals.modalViewSchedule.text.6')}} {{ dataStudent.levelAbbreviationGroup}}</label>
							</div>
						</div>
						<div class="form-group">
							<h4>{{$t('modals.modalViewSchedule.text.7')}}</h4>
							<span>
								<p style="white-space: pre-line;" class="bold">{{dataStudent.strSubjects}}</p>
							</span>
						</div>
					</div>
					<b-form inline v-if="!this.dataStudent.flagPlanTest">
            <label class="mr-sm-3">{{$t('modals.modalViewSchedule.text.1')}}</label>
            <b-form-datepicker
              style="min-width:154px" 
						  :locale="lang"
              :hide-header="true" 
              v-model="SelectBeginningDate"
						  :value-as-date="true" 
              :disabled="disabledDate"
              :min ="minDate"
              :max ="maxDate"
						  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
            <icon name="info" class="icon-info ml-2" v-b-tooltip.hover :title="$t('title.5')" />
          </b-form>
				</b-col>
          
				<b-col class="text">
					<div v-if="changingValue==0 " class="content-changue">
						<p v-if="typeOption == 1 && flagConflict">
              {{$t('modals.modalViewSchedule.text.2')}} <br>
						</p>
            <p v-if="typeOption == 1 && !flagConflict">
              Click Accept to apply for this class, or Edit Schedule. Once you send the proposal, please wait for the student's response.
              <br>
						</p>
            <p v-if="typeOption == 2 && !flagConflict">
              Click Accept to apply for this class, Reject to reject this class, or Edit Schedule. Once you send the proposal, please wait for the student's response.
              <br>
						</p>
					</div>
					<div v-else-if="changingValue==1" class="content-changue" style="flex-direction: column;">
						<!-- <p>I wantto <a href="#">carcel this schedule</a></p> -->

						<p class="d-flex align-items-center">{{editHourTotal}} hrs / {{hourTotal}} hrs <span class="ml-2 icon-info" v-b-tooltip.hover :title="`${$t('title.16')}`"><img class="svg" src="@/assets/icons/icon-info.svg"></span></p>

            <b-alert show variant="danger" class="mt-3"
						v-if="alertHours"
						>{{$t('modals.modalViewSchedule.text.3')}} {{ dataStudent.flagPlanTest ? hourTotal :  hourTotal*(75/100) }} {{$t('modals.modalViewSchedule.text.4')}}</b-alert>
					</div>
					<div v-else class="content-changue">
						<p>Please wait for {{(dataStudent.className.split(' ')[0])}} to accept, reject, or edit this proposal.</p>
					</div>
					<div class="d-flex" v-if="showActions">
            <div v-if="disabledButtons" style="display: flex;">
              <template v-if="dataStudent.typeScheduleValue != 4 && dataStudent.typeScheduleValue != 3">
                <b-button variant="primary" class="btn-gris"  @click="$bvModal.show('modal-schedule-acept')" v-if="changingValue==0" :disabled="flagConflict">
                  {{$t('modals.modalViewSchedule.button-acept')}}
                </b-button>
                <b-button variant="primary" class="btn-gris ml-2"  :disabled="alertHours"  @click="$bvModal.show('modal-schedule-send')" v-if="changingValue==1">{{$t('modals.modalViewSchedule.button-acept')}}</b-button>
              
                <b-button @click="editCalendarHorario(1)" v-if="changingValue==0" variant="outline-primary" class="btn-outline ml-2"><icon name="edit-pencil" />{{$t('modals.modalViewSchedule.button-edit')}}</b-button>
                <b-button variant="outline-danger" class="ml-2" @click="editCalendarHorario(2)"   v-else-if="changingValue==1"><icon name="undo" />{{$t('modals.modalViewSchedule.button-reply')}}</b-button>
                <b-button  variant="danger" class="btn btn-danger ml-2" v-b-modal.modal-schedule-reject  v-if="typeOption == 1 ? dataStudent.typeProposalId  ? dataStudent.typeProposalId== 48 && changingValue ==0 ? true : false : false : true" >{{$t('modals.modalViewSchedule.button-reject')}}</b-button>
              </template>
              <template v-else>
                <b-button variant="danger"  v-b-modal.modal-schedule-cancel>{{$t('modals.modalViewSchedule.button-cancel')}}</b-button>
              </template>
            </div>
       
            
						
            
						<!-- <b-button variant="outline-primary" class="outline"><i class="material-icons">edit</i>Tomar las clases</b-button> -->
					</div>
				</b-col>
			</b-row>
      <b-row v-else>
        
        <div style="width:100%;" v-if="showEditStudent">
        
          <b-row>
            <b-col  class="text availability">
              <div class="content-changue">
                <p>
                   {{$t('modals.modalViewSchedule.text.9')}}   {{dataTeacher.strFullName}}
                </p>
               
              </div>
            </b-col>
              </b-row> 
              <b-row style="padding: 35px 20px 0px 20px;">
                  <b-col>
                <b-form inline v-if="!flagPlanTest">
          
                  <label class="mr-sm-3">{{$t('horario.calendario.fecha')}}</label>
                  <b-form-datepicker  
                    :locale="lang"
                    :hide-header="true" 
                    direction="right" 
                    v-model="SelectBeginningDate"
                    :dropright="true" 
                    :value-as-date="true" 
                    :disabled="disabledDate"
                    :min ="minDate"
                    :max ="maxDate"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
                  </b-form>   
          
            </b-col>
            <b-col style="display: flex;justify-content: end;">
              <b-button variant="primary" class="btn-gris"   @click="$bvModal.show('modal-schedule-send')" >{{$t('modals.modalViewSchedule.button-resend')}}</b-button>
              <b-button variant="danger" class="ml-4"  v-b-modal.modal-schedule-cancel>{{$t('modals.modalViewSchedule.button-cancel')}}</b-button>
            </b-col>
          
          </b-row> 
            
        </div>
        <div class="w-100 d-flex" v-else>
          <b-col>
              <div class="card card_teacher list availability active">
                <div class="d-flex align-items-center">
                    <div class="perfil">
                        <b-avatar
                        :src="dataTeacher.person ? dataTeacher.person.photo ? dataTeacher.person.photo : urlPhoto.PHOTO_TEACHER_DEFAULT : urlPhoto.PHOTO_TEACHER_DEFAULT"
                        size="4.3rem"
                        ></b-avatar>
                        <b-form-rating :value="dataTeacher.totalQualification ? dataTeacher.totalQualification : 0" no-border readonly></b-form-rating>
                    </div>
                    <div class="info">
                        <h6>{{dataTeacher.person ? dataTeacher.person.strFullName : ''}}</h6>
                        <p>
                        <icon name="location" />{{dataTeacher.person ? dataTeacher.person.countryOriginDescription : '-'}}
                        </p>
                    </div>
                </div>
                <div
                    class="d-flex align-items-center justify-content-between link-youtube"  style="margin-top: 1px !important;"
                >
                    <b-link @click="showTeacherInfoComment(dataTeacher.id)">{{dataTeacher.totalCommentary ? dataTeacher.totalCommentary : 0}} {{$t('modals.modalViewSchedule.opinions')}}</b-link>                                      
                    
                    <b-icon v-if="dataTeacher.urlVideoFormat != null && dataTeacher.urlVideoFormat != ''" class="icon" icon="youtube" @click="openVideo(dataTeacher.urlVideoFormat)"/>                    
                    <b-icon v-else class="icon icon-yout-disabled" icon="youtube" />
                </div>
              </div>
          </b-col>
          <b-col  class="text availability">
              <div class="content-changue">
                <p v-if="!dataTeacher.flagEnviado">
                  <a href="#" class="bold" @click="showModalAndDate" >{{$t('modals.modalViewSchedule.else.button')}}</a>
                   <!-- <span v-else>{{$t('modals.modalViewSchedule.else.button')}}</span>-->
                  {{$t('modals.modalViewSchedule.else.text.1')}} {{dataTeacher.person ? dataTeacher.person.firstName : ''}}
                </p>
                 <p v-else>
                
                  {{$t('modals.modalViewSchedule.else.text.2')}} {{dataTeacher.person ? dataTeacher.person.firstName : ''}}
                </p>
              </div>
          </b-col>
        </div>
      </b-row>
			<!------------------------modal ----------------------------->
      	<div>
				<b-modal id="modal-schedule-acept"
					:hide-footer="false" 
          :hide-header="false"
          :hide-body="true" 
          :centered="true" 
          :no-close-on-esc="true">
          <template #modal-header="{ close }">
            <img class="close" src="@/assets/img/close_red.png" @click="close();showButtonAccept=true;">
            <p class="text-center">Are you sure you would like to apply to teach {{dataStudent.className}}?</p>
          </template>
          <div>
            <b-alert
              show
              variant="danger"
              style="padding: 5px; font-size: 0.95rem; text-align: center"
              v-if="crossingSchedule > 0 "
              >
              {{nameWarning}}
            </b-alert>
          </div>
          <template #modal-footer>
            <b-button variant="danger" @click="$bvModal.hide('modal-schedule-acept'),crossingSchedule = 0;showButtonAccept=true;">{{$t('modals.modalViewSchedule.modal-schedule-cancel.button-cancel')}}</b-button>
            <b-button v-if="showButtonAccept" @click="acceptCounterProposal" variant="primary">
              <template v-if="!showSpinnerAccept">{{$t('modals.modalViewSchedule.modal-schedule.text-acept')}}</template>
              <b-spinner
                style="width: 1rem !important; height: 1rem !important"
                v-else
                variant="light"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </template>
         
				</b-modal>
			</div>


   	<div>
				<b-modal id="modal-schedule-reject" style="    flex-direction: column;"
					:centered="true">
          <template #modal-header="{ close }">
            <img class="close" src="@/assets/img/close_red.png" @click="close()">
            <h5 style="text-align: center;">{{`${$t('modals.modalViewSchedule.modal-schedule-reject.sub-titulo-2')} ${dataStudent.className} ${$t('modals.modalViewSchedule.modal-schedule-reject.sub-titulo-3')}`}} </h5>	
          </template>
          <div>
            <b-form-group id="fieldset-1" class="w-100">
              <b-form-textarea v-model.trim="proposal.commentary" no-resize :placeholder="$t('modals.modalViewSchedule.modal-schedule-reject.motive')" rows="3"
                autofocus required v-bind:class="{ error: $v.proposal.commentary.$error}" @blur="$v.proposal.commentary.$touch()">
              </b-form-textarea>
              <span class="error-input">{{ validationMsgCommetary($v.proposal.commentary)}}</span>
            </b-form-group> 
          </div>
          <template #modal-footer>
            <b-button variant="danger" @click="$bvModal.hide('modal-schedule-reject'),crossingSchedule = 0">{{$t('modals.modalViewSchedule.modal-schedule-reject.button-cancel')}}</b-button>
            <b-button variant="primary" :disabled="$v.proposal.commentary.$invalid" @click="rejectCounterProposal" :class="{ loading: showSpinnerReject }">
              {{$t('modals.modalViewSchedule.modal-schedule.text-acept')}}
            </b-button>
            
          </template>
				</b-modal>
			</div>


      	<div>
				<b-modal id="modal-schedule-send"
          :centered="true" 
          :no-close-on-esc="true">
             <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
            </template>
            <p class="text-center mb-0" v-if="!flagCancelEdit">{{(flagDeleteEvent || arraySchedulePrivate.length>0)?$t('modals.modalViewSchedule.modal-schedule-send.text.1'):'Are you sure you would like to apply to teach'}} {{dataStudent.className}}?</p>
            <p class="text-center mb-0" v-else>{{$t('modals.modalViewSchedule.modal-schedule-resend.title')}} {{dataTeacher.strFullName}} ?</p>
            <b-alert
						show
						variant="danger"
						style="padding: 5px; font-size: 0.95rem; text-align: center"
						v-if="crossingSchedule > 0 "
						>{{nameWarning}}</b-alert>
					<!--{{$t('modals.modalViewSchedule.modal-schedule-send.alert')}}-->
          <template #modal-footer>
            <div class="w-100 d-flex justify-content-center">
              <b-button variant="danger" @click="$bvModal.hide('modal-schedule-send');crossingSchedule = 0">{{$t('modals.modalViewSchedule.modal-schedule-send.button-cancel')}}</b-button>
              <b-button class="ml-2" @click="sendCounterProposal" variant="primary" :class="{ loading: showSpinnerSend }">
                {{$t('modals.modalViewSchedule.modal-schedule-send.button')}}
              </b-button>
            </div>
           
          </template>
          <!-- <div class="mt-4" style="display: flex;justify-content: end;">
            <b-button variant="primary" @click="sendCounterProposal" class="mr-3">
              <span style="color:#ffffff" v-if="!showSpinnerSend">{{$t('modals.modalViewSchedule.modal-schedule-send.button')}}</span>
              	<b-spinner
				style="width: 1rem !important; height: 1rem !important"
				v-else
				variant="light"
				label="Spinning"
			></b-spinner>
            </b-button>
					  <b-button variant="danger" @click="$bvModal.hide('modal-schedule-send');crossingSchedule = 0">{{$t('modals.modalViewSchedule.modal-schedule-send.button-cancel')}}</b-button>
          </div> -->
					
				</b-modal>
			</div>

      
			<div>
				<b-modal id="modal-schedule-cancel" 
          :centered="true" 
          :no-close-on-esc="true">
          <template #modal-header="{ close }">
            <img class="close" src="@/assets/img/close_red.png" @click="close()">
          </template>
            <p class="text-center mb-0" v-if="!flagCancelEdit">{{$t('modals.modalViewSchedule.modal-schedule-cancel.titulo')}}</p>  
            <p class="text-center mb-0" v-else>{{$t('modals.modalViewSchedule.modal-schedule-cancel.titulo-2')}}</p>  
          <template #modal-footer>
            <div class="w-100 d-flex justify-content-center">
              <b-button variant="danger" class="mr-2" @click="$bvModal.hide('modal-schedule-cancel')">{{$t('modals.modalViewSchedule.modal-schedule-cancel.button-cancel')}}</b-button>
              <b-button @click="cancelCounterProposal" variant="primary">
                <template v-if="!showSpinnerCancel">{{$t('modals.modalViewSchedule.modal-schedule-cancel.button')}}</template>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                  variant="light"
                  label="Spinning"
                ></b-spinner>
              </b-button>
            </div>
          </template>
				</b-modal>
			</div>
			<!------------------------ fin - modal ----------------------------->
			<div class="calendar" style="margin-top:0px !important;">
         <div  class="content-changue" v-if="!disabledDate">
            <b-alert show variant="warning">{{$t('modals.modalViewSchedule.text.8')}}</b-alert>
        </div>
        <div v-if="showLoading" class="container-loading">
          <b-spinner :label="$t('reusables.loading')" ></b-spinner>
        </div>
				<FullCalendar v-else class="demo-app-calendar" :options="calendarOptions"  ref="fullCalendar">
            <template v-slot:eventContent="arg">
              <div class="fc-event-main-frame" :class="arg.event.className" >
               <!--!dataStudent.flagPlanTest &&-->
                <span v-if="arg.event.startEditable"  @click="removeEvent(arg.event)" style="cursor:pointer;" class="material-icons"
                  >clear</span
                >
                <div class="fc-event-time">{{arg.timeText}}</div>
                <div class="fc-event-title-container">
                  {{arg.event.title}}
                </div>
              </div>
            </template>
			</FullCalendar>
				<b-modal
					id="modal-add-event"
					centered
					@close="showAlertModal=false;
          $bvModal.hide('modal-add-event')"
				>
           <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
              <h5>{{$t('title.6')}}</h5>
            </template>
					<div>
				 <!--	<p>
						<span class="material-icons-outlined">class</span
						>{{ titleCourse }}
					</p>-->
					</div>
          <p class="d-flex align-items-center">
              <i class="material-icons-outlined mr-3">schedule</i>
              <span>{{
							this.eventCreated != null
							? getFormatDate(this.eventCreated.startStr, this.eventCreated.endStr, this.lang, dataStudent.flagPlanTest,maximoHorasCalendario)
							: ""
						}}</span>
          </p>
					<div>
					<b-alert
						show
						variant="danger"
						style="padding: 5px; font-size: 0.95rem; text-align: center"
						v-if="showAlertModal"
						>{{ message }}</b-alert
					>
					</div>
            <template #modal-footer>
              <b-button variant="danger" @click="showAlertModal=false;$bvModal.hide('modal-add-event')"> {{$t('modals.calendar.button')}} </b-button>
              <b-button @click="saveEvent" variant="primary">
              <template v-if="!showSpinnerSave">{{$t('modals.calendar.button-save')}}</template>
              <b-spinner
              style="width: 1rem !important; height: 1rem !important; color:#FFFFFF;"
              v-else
              
              label="Spinning"
              ></b-spinner>
            </b-button>
            
            </template>

				</b-modal>
			</div>
		</b-modal>

    <b-modal id="modal-send-request-view"
            centered @close='$bvModal.hide("modal-send-request-view")'
      >
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()">
      </template>
        <p>{{$t('modals.modalSendRequestView.exceeded-the-maximum-number-1')}} {{messageSendRequest}} {{$t('modals.modalSendRequestView.exceeded-the-maximum-number-2')}}</p>
      <template #modal-footer>
        <b-button  @click='$bvModal.hide("modal-send-request-view")' variant="primary">Aceptar</b-button>
      
      </template>
    </b-modal>
    <!-- <videoPerson/> -->

    <modalValidateProposal ref="refValidProposal" :typeResponseEvent="typeResponseEvent" :messageValidate="messageValidate" :flagTeacher="true"/>
    </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import interactionPlugin from "@fullcalendar/interaction";
import * as Constants from "@/assets/js/appConstants";
import { required } from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages';
import * as tools from '@/assets/js/tools.js';
import { IMAGENES } from '@/assets/js/appConstants'; 
import modalValidateProposal from "@/components/modals/modal-validate-proposal";
// import videoPerson from "@/components/modals/video-person";
import { getCalendarHeaderFormat, getCalendarTitle, getFormatDate, getCalendarEventTimeFormat,getCalendarHeaderToolbar , convertToUserTimeCalendarEvents, convertTimeCalendarEvents, getHoursByTimeZoneName, ValidarMergeHorarios} from '@/assets/js/util.js';

const formMessagesCommentary = {
  required: function() {
    return this.$t('modals.modalViewSchedule.modal-schedule-reject.validate');
  }
}

var _ctx = "";
let eventGuid = 0;
export function createEventId() {
  return String(eventGuid++);
}
export default {
  components: {
    FullCalendar,
    modalValidateProposal
    // videoPerson
  },
  props: {
    showActions: Boolean,
    pteacherDirectId: Number,
    pteacherData: Object
  },
  data() {
    return {
      flagDeleteEvent: false,
      flagSendRequest: false,
      messageSendRequest: '',
      disabledButtons: false,
      daysMaxSchedule: 0,
      flagShowHeader: false,
      urlPhoto: IMAGENES,
      lang: localStorage.getItem('lang') || 'es',
      arraySchedulePrivate: [],
      flagCancelEdit: false,
      showEditStudent: false,
      showModalPerson: false,
      nameWarning: '',
      hourPlanTest: [],
      hourEnabled: [],
      minDate: null,
      maxDate: null,
      disabledDate: true,
      dateStudent: null,
      typeOption: 1,
      flagConflict: false,
      showSpinnerReject: false,
      showSpinnerCancel: false,
      showSpinnerAccept: false,
      showSpinnerSend: false,
      dataStudent: {},
      dataTeacher: {},
      //colorEvent : "#cc0000",
      showLoading: false,
      directRequest: 0, //tab "Solicitud directa" ( numero varia que se muestra en este tab)
      changingValue: 0,
      events: [],
      API_URL: process.env.VUE_APP_API_URL,
      GroupScheduleCounterProposalId: 0,
      groupsScheduleProposalEditedId: null,
      PersonStudentId: 0,
      PersonTeacherId: 0,
      editHourTotal: 0,
      hourTotal: 0,
      arrayEditableSchedule: [],
      GroupId: 0,
      teacherAnswer: 1,
      FlagGroupRegisterSubject: false,
      totalCarousel: true,
      titleTeacher: true,
      showCarousel: false, //carousel ---------
      listCalendar: [],
      /*items: [
        { text: "Horario", href: "/horario" },
        { text: "Programar horario", active: true },
      ],*/
      calendarEdit: false,
      arrayCalendarInit: [],
      maximoHorasCalendario: 0,
      countCall: 1,
      numSave: 0,
      message: "",
      showSpinnerSave: false,
      showSpinner: false,
      showAlertModal: false,
      dismissSecs: 5,
      disbaledTabs: true,
      dismissCountDown: 0,
      showTitleCalendar: false,
      titleCourse: "",
      flagState: false,
      SelectBeginningDate: new Date(),
      SelectBeginningDateInit: new Date(),
      eventCreated: null,
      formatDay: "",
      new_appointment: {
        title: null,
        description: null,
      },
      showButtonAccept: true,
      calendarOptions: {
        eventOrder: "start,allDay,className",
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        //initialDate: new Date(),
        events: [],
        eventOverlap: false,
        themeSystem: "bootstrap",
        nowIndicator: true,
        firstDay: 1,
        //gotoDate: new Date('2018-06-01'),
        headerToolbar: this.getCalendarHeaderToolbarTestClass(this.flagShowHeader),
        buttonText: {
          today: this.$t('reusables.today'),
        },
        titleFormat: function(date) {
          return getCalendarTitle(date.date, this.lang);
        },
        height: "auto",
        allDaySlot: false,
        viewDidMount: (view) => {
          let GMT = getHoursByTimeZoneName(this.$moment, this.$store.state.user.timeZoneName);
          view.el.querySelector('.fc-timegrid-axis-frame').innerHTML = GMT;
        },
        initialView: "timeGridWeek",
        dayHeaderContent: (args) => {
          return getCalendarHeaderFormat(this.$moment, args.date, this.lang, this.formatDay);
        },
        eventTimeFormat: getCalendarEventTimeFormat(),
        initialEvents: [], //INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        scrollTimeReset: false,
        eventColor: Constants.CALENDAR_STATUS.CONFIRM.COLOR,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventResizableFromStart: false,
        select: this.handleDateSelect,

        selectAllow: this.handleSelecAllow,
        eventChange: this.handleEvents,


      },
      currentEvents: [],
      hoursEdit: 0,
      hourDisbaled: [],
      dataModal: {},
      crossingSchedule: 0,
      // value: '',
      proposal: {
        commentary: ""
      },
      getFormatDate: getFormatDate,
      typeResponseEvent: 0,
      messageValidate: ''
    }
  },
  watch: {
    /*changingValue:function(val){
    	console.log(val)
    	if(val==0)document.getElementById('btnScheduleDisabled').disabled = true;
    	else document.getElementById('btnScheduleDisabled').disabled = false;
    }*/
  },
  updated() {
    this.$nextTick(function() {
      tools.imgToSvg()
    })
  },
  async created() {
    this.disabledButtons = false;
    _ctx = this.API_URL;
  },

  computed: {
    teacherId: {
      get() {
        return this.$store.state.user.personTeacherId;
      }
    },
    alertHours() {
      let hoursSend = this.hourTotal * (75 / 100)

      return this.editHourTotal < hoursSend ? true : false
    },
    diabledButton() {
      let elmts = [];
      let arrayCalendar = [];
      let arrayCalendarInit = [];
      this.listCalendar.forEach((element) => {
        arrayCalendar.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      this.arrayCalendarInit.forEach((element) => {
        arrayCalendarInit.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      if (arrayCalendar.length > arrayCalendarInit.length) {
        elmts = arrayCalendar.filter(function(i) {
          return this.indexOf(i) < 0;
        }, arrayCalendarInit);
      } else {
        elmts = arrayCalendarInit.filter(function(i) {
          return this.indexOf(i) < 0;
        }, arrayCalendar);
      }

      return elmts.length == 0 ? true : false;
    },
  },
  // mounted(){
  //   this.$emit('value',this.showModalPerson)
  // },
  validations: {
    proposal: {
      commentary: {
        required
      }
    }
  },
  methods: {
    modalHideSchedule(){
      if(this.showActions == true){
           window.location.reload();
      }else{
        this.$bvModal.hide('modal-schedule'); 
      }
    },
    handleHideModal() {

      this.proposal.commentary = '';
      this.$v.$reset()

      this.changingValue = 0
      this.$bvModal.hide('modal-schedule-send');
      this.$bvModal.hide('modal-schedule');
      this.$emit('updateScheduleClassRequest');
      this.modalHideSchedule();
    },
    showModalEditStudent(flagEditStudent, dataTeacher, groupsScheduleProposalEditedId, flagPlanTest) {

      this.dataTeacher = dataTeacher
      this.showEditStudent = flagEditStudent;
      this.flagPlanTest = flagPlanTest
      this.groupsScheduleProposalEditedId = groupsScheduleProposalEditedId
      this.formatDay = ''
      this.$bvModal.show('modal-schedule')
      this.flagCancelEdit = true;
      this.calendarOptions.selectable = false;
      this.getListSheduleEdit();
    },

    getListSheduleEdit() {
      this.showLoading = true;
      this.listCalendar = [];
      let data = {
        GroupScheduleProposalId: this.groupsScheduleProposalEditedId,
        isConsolidated: true,
      }

      baseInstanceAxios.get(`${this.apiURL}/resources/GroupScheduleCounterProposal/GetEditionScheduleByIdByStudent`, {
        params: data
      }).then(response => {

        if (response.data.entity) {
          this.SelectBeginningDate = response.data.entity.beginningDate


          //let arrayHours = response.data.entity.listGroupScheduleProposalDetails; //TODO: PENDIENTE TIMEZONE

          let arrayHoursTmp = response.data.entity.listGroupScheduleCounterProposalDetails;
          let arrayHours = convertToUserTimeCalendarEvents(arrayHoursTmp, this.$store.state.user.timeZoneName, this.$moment);

          let dataList = []
          arrayHours.forEach((element) => {

            this.arrayEditableSchedule.push(element.id)
            let jsonData = {
              id: createEventId(),
              title: this.$t('horario.solicitud.pending-schedule'),
              description: "",
              idx: element.id,
              start: element.startDate,
              end: element.endDate,
              color: Constants.CALENDAR_STATUS.CONFIRM.COLOR,
              editable: false
            };

            dataList.push(jsonData);
            let data = {
              id: element.id,
              StartDate: element.startDate,
              EndDate: element.endDate,
            };
            this.listCalendar.push(data);


          });


          this.calendarOptions.events = dataList;

        }
        this.showLoading = false;

        setTimeout(() => {
          if (this.listCalendar.length > 0) {

            let calendarApi = this.$refs.fullCalendar.getApi();
            calendarApi.gotoDate(this.listCalendar[0].StartDate);
          }
        }, 500);

      })
    },
    async getDataPlan(groupId) {
      let data = {
        TeacherId: this.teacherId,
        GroupId: groupId
      }
      await baseInstanceAxios.get(`${this.apiURL}/resources/GroupsCoursesLessons/EntitySchedulePlanTestByTeacher`, {
        params: data
      }).then(response => {

        if (response.data.entity) {

          this.maximoHorasCalendario = response.data.entity.maximoHorasCalendario
          this.daysMaxSchedule = response.data.entity.daysMaxSchedule

          if (this.dataStudent.flagPlanTest) {
            this.maximoHorasCalendario = response.data.entity.durationClassTest / 60
            this.daysMaxSchedule = response.data.entity.daysMaxScheduleTest + 1
          }

        }

      })
    },

    validationMsgCommetary: validationMessage(formMessagesCommentary),

    openVideo(urlVideo) {
      console.log(urlVideo == "");

      this.showModalPerson = true;
      this.$emit('value', {
        flag: this.showModalPerson,
        urlVideo: urlVideo
      })
    },

    handleSelecAllow(selectInfo) {

      if (this.dataStudent.flagPlanTest) {
        let dateCurrent = new Date();
        let newDateCurrent = new Date(dateCurrent.setMinutes(dateCurrent.getMinutes() - this.maximoHorasCalendario * 60))
        let dataAfter = this.$moment(newDateCurrent).add(this.daysMaxSchedule - 1, 'days')
        let dataStar = this.$moment(selectInfo.start)
        let valueBefore = this.$moment(dataStar).isSameOrBefore(dataAfter);
        let valueAfter = this.$moment(new Date(selectInfo.start)).isAfter(new Date());
        let dateSelectStart = new Date(selectInfo.start)
        let endAfter = selectInfo.end
        let arraySend = this.listCalendar.filter((currentValue) => {
          return currentValue.request
        })
        if (arraySend.length == 1) {
          return false;
        }

        let dateAfter = new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60))

        if (endAfter.getTime() <= dateAfter.getTime() && (valueBefore && valueAfter)) {
          return true
        } else {
          return false
        }

      } else {
        if (this.editHourTotal == this.hourTotal) {
          return false;
        }
        let num = this.ObtenerRangoFecha(selectInfo.startStr, selectInfo.endStr, this.listCalendar)
        if (num > 0) {
          return false;
        }

        let dateSelectStart = new Date(selectInfo.start)
        let endAfter = selectInfo.end

        let dateAfter = new Date(dateSelectStart.setHours(dateSelectStart.getHours() + 6))

        if (endAfter.getTime() <= dateAfter.getTime()) {
          return true
        } else {
          return false
        }
      }

    },

    async rejectCounterProposal() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.showSpinnerReject = true;
      let json = {
        GroupScheduleCounterProposalId: this.GroupScheduleCounterProposalId,
        Value: this.proposal.commentary,
        UserMail: this.$store.state.user.email
      }

      let flagContinue = await this.validateCounterProposal(json.GroupScheduleCounterProposalId);
      if (!flagContinue) {
        return;
      }

      baseInstanceAxios
        .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/RejectScheduleCounterByTeacher`, json)
        .then((response) => {


          this.message = this.$t('horario.solicitud.msg-1'); //"Se rechazó correctamente la contrapropuesta o solicitud."
          this.$bvToast.show("toast-check-modal-request-class");
          //this.$emit('updateSchedule')
          this.showSpinnerReject = false;
          this.$bvModal.hide('modal-schedule-cancel');
          this.$bvModal.hide('modal-schedule');
          this.$emit('updateSchedule');
          this.modalHideSchedule();
        });
    },

    cancelCounterProposal() {
      this.showSpinnerCancel = true;
      if (this.flagCancelEdit) {
        let data = {
          GroupScheduleProposalId: this.groupsScheduleProposalEditedId
        }
        baseInstanceAxios.get(`${this.apiURL}/resources/GroupScheduleCounterProposal/CancelEditionScheduleByTeacher`, {
          params: data
        }).then(response => {

          this.message = this.$t('horario.solicitud.msg-2'); //`Se ha cancelado correctamente.`;

          this.$bvToast.show("toast-check-modal-request-class");
          this.$bvModal.hide('modal-schedule-cancel');
          this.$bvModal.hide('modal-schedule');
          this.$emit('updateSchedule')
          this.showSpinnerCancel = false;
          this.modalHideSchedule();

        }).catch(err => {
          this.showSpinnerCancel = false;
          this.message = this.$t('horario.solicitud.msg-3'); //`Hubo un error al cancelar el horario nuevo pendiente.`;

          this.$bvToast.show("toast-equis-modal-request-class");
        });
      } else {

        let json = {
          GroupScheduleCounterProposalId: this.GroupScheduleCounterProposalId,
          Code: Constants.TYPE_SCHEDULE_SEND.EARRING.CODE,
          Value: Constants.TYPE_SCHEDULE_SEND.EARRING.VALUE,
          BeginningDate: this.SelectBeginningDate,
          UserMail: this.$store.state.user.email
        }

        baseInstanceAxios
          .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/AcceptCancelScheduleCounterByTeacher`, json)
          .then((response) => {


            this.message = this.$t('horario.solicitud.msg-4'); //"Se canceló correctamente su contrapropuesta."
            this.$bvToast.show("toast-check-modal-request-class");
            //this.$emit('updateSchedule')
            this.showSpinnerCancel = false;
            this.$bvModal.hide('modal-schedule-cancel');
            this.$bvModal.hide('modal-schedule');
            this.$emit('updateSchedule');
            this.modalHideSchedule();
          });
      }

    },

    async acceptCounterProposal() {

      this.crossingSchedule = 0
      let arrayScheduleTeacher = this.listCalendar.filter((currentValue) => {
        return !currentValue.request && !currentValue.flagPlantTest
      })

      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request
      })

      let arrayNotAvailable = this.listCalendar.filter((currentValue) => {
        return !currentValue.request
      })

      let sumtotal = 0
      let arrayNew = []

      arraySend.forEach(element => {
        arrayNew.push({
          StartDate: element.StartDate,
          EndDate: element.EndDate
        })
        let flagRangoFecha = this.ObtenerRangoFecha(element.StartDate, element.EndDate, arrayNotAvailable);
        sumtotal += flagRangoFecha
      });

      if (this.dataStudent.flagPlanTest) {
        this.SelectBeginningDate = new Date(arrayNew[0].StartDate)
      }

      let json = {
        GroupScheduleCounterProposalId: this.GroupScheduleCounterProposalId,
        Code: Constants.TYPE_SCHEDULE_SEND.ACCEPTED.CODE,
        Value: Constants.TYPE_SCHEDULE_SEND.ACCEPTED.VALUE,
        BeginningDate: this.SelectBeginningDate,
        FlagPlanTest: this.dataStudent.flagPlanTest,
        UserMail: this.$store.state.user.email
      }

      if (!this.disabledDate) {

        let dateCurrent = new Date(this.SelectBeginningDate)

        let dateCurrentFormat = new Date(dateCurrent.getFullYear(), dateCurrent.getMonth(), dateCurrent.getDate(), 0, 0, 0)
        let dateMinFormat = new Date(this.minDate.getFullYear(), this.minDate.getMonth(), this.minDate.getDate(), 0, 0, 0)
        if (this.$moment(dateCurrentFormat).isSameOrAfter(dateMinFormat)) {
          this.showSpinnerAccept = true;

          let sumSchedule = 0
          arraySend.forEach(element => {
            let flagRangoFecha = this.ObtenerRangoFecha(element.StartDate, element.EndDate, arrayScheduleTeacher);

            sumSchedule += flagRangoFecha
          });


          if (sumSchedule == 0) {
            this.showSpinnerAccept = true;

            let flagContinue = await this.validateCounterProposal(json.GroupScheduleCounterProposalId);
            if (!flagContinue) {
              return;
            }
            baseInstanceAxios
              .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/AcceptCancelScheduleCounterByTeacher`, json)
              .then((response) => {

                this.message = this.$t('horario.solicitud.msg-5'); //"Se aceptó correctamente la contrapropuesta o solicitud."
                this.$bvToast.show("toast-check-modal-request-class");
                //this.$emit('updateSchedule')
                this.showSpinnerAccept = false;
                this.$bvModal.hide('modal-schedule-acept');
                this.$bvModal.hide('modal-schedule');
                this.$emit('updateSchedule');
                this.modalHideSchedule();
              });
          } else {
            this.showSpinnerAccept = false;
            this.crossingSchedule = 1
            this.showButtonAccept = false;
            this.nameWarning = this.$t('view-schedule.validate.1')
          }


        } else {
          this.showSpinnerAccept = false;
          this.crossingSchedule = 1
          this.nameWarning = this.$t('horario.solicitud.msg-6'); //"Debes cambiar la fecha de inicio a una fecha posterior del ultimo cruce de la clase de prueba."
        }
      } else {
        this.crossingSchedule = sumtotal
        if (sumtotal == 0) {
          this.showSpinnerAccept = true;

          let flagContinue = await this.validateCounterProposal(json.GroupScheduleCounterProposalId);
          if (!flagContinue) {
            return;
          }
          baseInstanceAxios
            .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/AcceptCancelScheduleCounterByTeacher`, json)
            .then((response) => {


              this.message = this.$t('horario.solicitud.msg-5');
              this.$bvToast.show("toast-check-modal-request-class");
              //this.$emit('updateSchedule')
              this.showSpinnerAccept = false;
              this.$bvModal.hide('modal-schedule-acept');
              this.$bvModal.hide('modal-schedule');
              this.$emit('updateSchedule');
              this.modalHideSchedule();
            });
        } else {
          this.showSpinnerAccept = false;
          this.showButtonAccept = false;
          this.nameWarning = this.$t('view-schedule.validate.1')
        }
      }

    },

    async sendCounterProposal() {
      //this.changingValue++
      if (this.flagCancelEdit) {
        this.showSpinnerSend = true;

        let data = {
          GroupScheduleProposalId: this.groupsScheduleProposalEditedId,
          UserMail: this.$store.state.user.email
        }
        //GH => Consultar
        baseInstanceAxios.get(`${this.apiURL}/resources/GroupScheduleCounterProposal/ResendChangRequest`, {
          params: data
        }).then(response => {

          if (response.data.value == 0) {
            this.message = this.$t('horario.solicitud.msg-7');
            this.$bvToast.show("toast-equis-modal-request-class");
          }

          if (response.data.value == 1) {
            this.message = this.$t('horario.solicitud.msg-8');
            this.$bvToast.show("toast-equis-modal-request-class");
          }

          if (response.data.value == 2) {
            this.message = this.$t('horario.solicitud.msg-9');
            this.$bvToast.show("toast-check-modal-request-class");
            this.$bvModal.hide('modal-schedule-cancel');
            this.$bvModal.hide('modal-schedule');
            this.$emit('updateSchedule');
            this.modalHideSchedule();
          }

          this.showSpinnerSend = false;


        }).catch(err => {
          this.showSpinnerSend = false;
          this.message = this.$t('horario.solicitud.msg-10');
          this.$bvToast.show("toast-equis-modal-request-class");
        });
      } else {
        this.crossingSchedule = 0

        let sumtotal = 0
        let arrayScheduleTeacher = this.listCalendar.filter((currentValue) => {
          return !currentValue.request && !currentValue.flagPlantTest
        })
        let arraySend = this.listCalendar.filter((currentValue) => {
          return currentValue.request
        })

        let arrayNotAvailable = this.listCalendar.filter((currentValue) => {
          return !currentValue.request
        })



        let arrayNew = []
        arraySend.forEach(element => {
          arrayNew.push({
            StartDate: element.StartDate,
            EndDate: element.EndDate
          })
          let flagRangoFecha = this.ObtenerRangoFecha(element.StartDate, element.EndDate, arrayNotAvailable);

          sumtotal += flagRangoFecha
        });

        if (this.dataStudent.flagPlanTest) {
          this.SelectBeginningDate = new Date(arrayNew[0].StartDate)
        }
        this.dataModal = {
          PersonTeacherId: this.PersonTeacherId,
          BeginningDate: this.SelectBeginningDate,
          Code: Constants.TYPE_PROPOSAL_SEND.TEACHER_PROPOSAL.CODE,
          Value: Constants.TYPE_PROPOSAL_SEND.TEACHER_PROPOSAL.VALUE,
          GroupScheduleCounterProposalID: this.GroupScheduleCounterProposalId,
          ListGroupScheduleCounterProposalDetails: arrayNew,
          FlagPlanTest: this.dataStudent.flagPlanTest,
          UserMail: this.$store.state.user.email
          //ListScheduleTeachersDetails: []
        }

        if (!this.disabledDate) {
          let dateCurrent = new Date(this.SelectBeginningDate)

          let dateCurrentFormat = new Date(dateCurrent.getFullYear(), dateCurrent.getMonth(), dateCurrent.getDate(), 0, 0, 0)
          let dateMinFormat = new Date(this.minDate.getFullYear(), this.minDate.getMonth(), this.minDate.getDate(), 0, 0, 0)
          if (this.$moment(dateCurrentFormat).isSameOrAfter(dateMinFormat)) {
            this.showSpinnerSend = true;
            let sumSchedule = 0

            arraySend.forEach(element => {
              let flagRangoFecha = this.ObtenerRangoFecha(element.StartDate, element.EndDate, arrayScheduleTeacher);

              sumSchedule += flagRangoFecha
            });


            if (sumSchedule == 0) {
              convertTimeCalendarEvents(this.dataModal.ListGroupScheduleCounterProposalDetails, this.$store.state.user.timeZoneName, this.$moment);
              let flagContinue = await this.validateCounterProposal(this.dataModal.GroupScheduleCounterProposalID);
              if (!flagContinue) {
                return;
              }

              this.showSpinnerSend = true;

              baseInstanceAxios
                .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/SaveScheduleTeacherAvailabilityAndCounterProposal`, this.dataModal)
                .then((response) => {

                  this.showSpinnerSave = false;
                  this.message = this.$t('modals.modalConfirmPrivate.message-success')
                  this.$bvToast.show("toast-check-modal-request-class");
                  //this.$emit('updateSchedule')
                  this.showSpinnerSend = false;
                  this.editCalendarHorario(2);
                  this.$bvModal.hide('modal-schedule-send');
                  this.$bvModal.hide('modal-schedule');
                  this.$emit('updateSchedule');
                  this.modalHideSchedule();
                });
            } else {
              this.showSpinnerSend = false;
              this.crossingSchedule = 1
              this.nameWarning = this.$t('view-schedule.validate.1')
            }
          } else {
            this.showSpinnerSend = false;
            this.crossingSchedule = 1
            this.nameWarning = this.$t('horario.solicitud.msg-6');
          }
        } else {
          this.crossingSchedule = sumtotal
          if (sumtotal == 0) {
            this.showSpinnerSend = true;

            convertTimeCalendarEvents(this.dataModal.ListGroupScheduleCounterProposalDetails, this.$store.state.user.timeZoneName, this.$moment);
            let flagContinue = await this.validateCounterProposal(this.dataModal.GroupScheduleCounterProposalID);
            if (!flagContinue) {
              return;
            }
            baseInstanceAxios
              .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/SaveScheduleTeacherAvailabilityAndCounterProposal`, this.dataModal)
              .then((response) => {

                this.showSpinnerSave = false;
                this.message = this.$t('modals.modalConfirmPrivate.message-success')
                this.$bvToast.show("toast-check-modal-request-class");
                //this.$emit('updateSchedule')
                this.showSpinnerSend = false;
                this.editCalendarHorario(2);
                this.$bvModal.hide('modal-schedule-send');
                this.$bvModal.hide('modal-schedule');
                this.$emit('updateSchedule');
                this.modalHideSchedule();
              });
          } else {
            this.showSpinnerSend = false;
            this.nameWarning = this.$t('view-schedule.validate.1')
          }
        }

      }



    },

    editCalendarHorario(type) {

      //this.btnSend = true;
      //this.btnOutCarousel = false;
      if (type == 1) {
        this.changingValue++
        this.calendarOptions.selectable = true;

        this.arrayEditableSchedule.forEach(id => {

          this.calendarOptions.events.forEach(element => {

            if (element.idx == id) {
              element.editable = true;
            }
          });
        });

      } else {
        this.changingValue--
        this.getListHours();
      }


    },
    async ValidateIsScheduleDirectTotal() {
      let query = {
        GroupId: this.$store.state.group_id
      }

      await baseInstanceAxios
        .get(`${this.apiURL}/Resources/PersonsTeachers/ValidateIsScheduleDirectTotal`, {
          params: query
        })
        .then(response => {
          if (response.data) {

            this.flagSendRequest = response.data.return;
            this.messageSendRequest = response.data.message;
          }

        })
        .catch(err => {
          console.log("err : ", err)
        })
    },
    async showModalAndDate() {
      await this.ValidateIsScheduleDirectTotal();

      if (this.flagSendRequest) {
        this.$bvModal.show('modal-send-request-view')
      } else {
        this.$bvModal.hide('modal-schedule');
        //this.directRequest=1;
        //this.$emit('RequestDirect',this.directRequest)
        this.$emit('getParamsChild');
        this.$emit('getListScheduleTeacherModal', this.pteacherDirectId);
      }

    },

    getScheduleTeacher(teacherId, groupId, flagEdited, teacherData, flagPlanTest) {

      this.dataTeacher = teacherData
      this.$bvModal.show('modal-schedule')
      this.getListScheduleTeacher(teacherId, groupId, flagEdited, flagPlanTest)
    },

    getListScheduleTeacher(id, groupId, flagEdited, flagPlanTest) {
      this.showLoading = true;
      let data = {
        PersonTeacherId: id,
        GroupId: groupId,
        FlagChangeTeacher: flagEdited,
        FlagPlanTest: flagPlanTest,
        timeZoneName: this.$store.state.user.timeZoneName
      }


      baseInstanceAxios
        .get(_ctx + "/resources/PersonsTeachers/GetByIdTeacherAvailability", {
          params: data
        })
        .then((response) => {
          let arrayHours = response.data.entity.dtoScheduleTeachersDetails; //TODO: PENDIENTE TIMEZONE


          this.SelectBeginningDate = response.data.entity.beginningDate;
          let dataList = [];
          let id = 0
          arrayHours.forEach((element) => {

            let colorResquest = "";
            let titleClass = ""

            if (Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST == element.typeOfSchedule || Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE == element.typeOfSchedule) {

              titleClass = this.$t('reusables.student');;

              colorResquest = Constants.CALENDAR_STATUS.CONFIRM.COLOR;
              this.arrayEditableSchedule.push(id)

            }
            if (Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER == element.typeOfSchedule) {

              //colorResquest = "#03c2fc"; 
              colorResquest = Constants.CALENDAR_STATUS.PENDIENT.COLOR;
              //titleClass = `Clases - ${element.persons.strFullName}`
              titleClass = this.$t('reusables.class-scheduled')
              if (element.flagPlanTest) {
                titleClass = this.$t('reusables.test-class'); //"Clase de prueba";
              }

              let jsonData = {
                id: createEventId(),
                title: titleClass,
                description: "",
                idx: id,
                start: element.startDate,
                end: element.endDate,
                color: colorResquest,
                editable: false
              };

              let data = {
                id: id,
                StartDate: element.startDate,
                EndDate: element.endDate,
                request: element.id != 0 ? true : false
              };
              id++;
              dataList.push(jsonData);
              this.listCalendar.push(data);
            }
            if (Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE == element.typeOfSchedule) {

              colorResquest = Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR;
              titleClass = this.$t('view-schedule.titleClass.3')

              let jsonData = {
                id: createEventId(),
                title: titleClass,
                description: "",
                idx: id,
                start: element.startDate,
                end: element.endDate,
                color: colorResquest,
                editable: false
              };

              let data = {
                id: id,
                StartDate: element.startDate,
                EndDate: element.endDate,
                request: element.id != 0 ? true : false
              };
              id++;
              dataList.push(jsonData);
              this.listCalendar.push(data);
            }


          });
          this.calendarOptions.events = dataList;

          setTimeout(() => {
            if (dataList.length > 0) {
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.gotoDate(dataList[0].start);
            }
          }, 500);

          this.calendarOptions.selectable = false;

          this.showLoading = false;

        })
        .catch(err => {
          console.log("err : ", err)
        })
    },

    async getId(scheduleCounterProposalId, dataStudent, type, percentage) {
      //console.log("dataStudent: ",dataStudent)

      this.dataStudent = dataStudent
      this.disabledButtons = false;
      this.showLoading = true;
      this.typeOption = type;
      this.flagConflict = percentage == 100 ? false : true;

      //TODO: QUITAR ESOS NROS HARDCODEADOS
      this.changingValue = dataStudent.typeScheduleValue != 4 && dataStudent.typeScheduleValue != 3 ? 0 : 2;

      this.PersonTeacherId = this.dataStudent.personTeacherId

      this.GroupScheduleCounterProposalId = scheduleCounterProposalId;
      await this.getDataPlan(dataStudent.groupsId);

      if (this.dataStudent.flagPlanTest) {
        this.flagShowHeader = true;
        this.formatDay = 'DD'
        this.calendarOptions.validRange = {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().add(this.daysMaxSchedule, 'days').format('YYYY-MM-DD'),
        };
      } else {

        this.flagShowHeader = false;
        this.formatDay = ' '
        this.calendarOptions.validRange = {
          start: null,
          end: null,
        };
      }
      this.calendarOptions.headerToolbar = this.getCalendarHeaderToolbarTestClass(this.flagShowHeader);
      this.getListHours();
    },


    openModalmorebtnDisabled() {
      this.$bvModal.show('modal-schedule')
      setTimeout(() => {
        if (this.changingValue == 0) {
          document.getElementById('btnScheduleDisabled').disabled = true;
        }
      }, 10)
    },

    saveEvent() {
      
      let fechaInicio = this.eventCreated.startStr;
      let dateSelectStart = new Date(fechaInicio)
      let dateEndNewView = this.eventCreated.endStr
      if (this.dataStudent.flagPlanTest) {
        let dateAfter = new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60))
        dateEndNewView = dateAfter
      }
      let num = this.ObtenerRangoFecha(fechaInicio, dateEndNewView, this.listCalendar)
      if (num == 0) {
        this.editHourTotal += this.hoursEdit
        let dataTmp = this.listCalendar;
        let idx = 0;

        let ultId =
          dataTmp.length == 0 ?
          1 * -1000 :
          dataTmp[dataTmp.length - 1].id;
        ultId = ultId == null ? 0 : ultId;
        idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;

        let _eventItemMerge = ValidarMergeHorarios(this.calendarOptions.events, fechaInicio, dateEndNewView, this.$moment);
            
        if(Object.keys(_eventItemMerge ).length != 0) { //si hay merge
          this.listCalendar.forEach((obj, i) => {
        
            if(obj.id == (_eventItemMerge.idx == 0 ? _eventItemMerge.id : parseInt(_eventItemMerge.idx, 10)) ) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format('YYYY-MM-DDTHH:mm:ss');
              obj.EndDate = this.$moment(_eventItemMerge.end).format('YYYY-MM-DDTHH:mm:ss');
              //obj.id = idx;
            }
          })
        
        }else{
          console.log("nuevo id: " + idx);
          let data2 = {
            id: idx, 
            StartDate: this.$moment(fechaInicio).format('YYYY-MM-DDTHH:mm:ss'),
            EndDate: this.$moment(dateEndNewView).format('YYYY-MM-DDTHH:mm:ss'),
            request: true
          };
          this.listCalendar.push(data2);

          this.calendarOptions.events.push({
            idx: idx,
            id: createEventId(),
            //start: this.eventCreated.startStr,
            start: this.$moment(this.eventCreated.startStr).format('YYYY-MM-DDTHH:mm:ss'),
            end: this.$moment(dateEndNewView).format('YYYY-MM-DDTHH:mm:ss'),
            description: "",
            title: (this.lang == 'en' ? 'Class - ' : "Clases - ") + this.dataStudent.className,
            editable: true
          });

        }


        


      } else {
        this.message = `${this.$t('modals.modalViewSchedule.maximoHorasCalendario.1')} ${this.maximoHorasCalendario*60} ${this.$t('modals.modalViewSchedule.maximoHorasCalendario.2')} `;
        this.$bvToast.show("toast-equis-modal-request-class");
      }

      this.$bvModal.hide("modal-add-event");

    },

    removeEvent(event) { 
      console.log("removeEvent id: " + event.extendedProps.idx);
      if (event.startEditable) {
        this.flagDeleteEvent = true;
        let startDate = new Date(event.startStr);
        let endDate = new Date(event.endStr);
        let seconds = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60)
        this.editHourTotal -= seconds

        this.listCalendar = this.listCalendar.filter(function(e) {
          return (parseInt(e.id) != parseInt(event.extendedProps.idx));
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(function(e) {
            return (parseInt(e.id) != parseInt(event.id));
          }
        )
        
 
        event.remove();

      }

      if(this.calendarOptions.events.length != this.listCalendar.length){
        alert("Error")
      }
      this.getNotSchedulecrossing();

    },


    handleDateSelect(selectInfo) {

      this.hoursEdit = 0;
      let missingHour = this.hourTotal - this.editHourTotal
      let startDate = new Date(selectInfo.startStr);
      let startDate1 = new Date(selectInfo.startStr);
      let endDate = new Date(selectInfo.endStr);

      let seconds = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60)

      if (this.dataStudent.flagPlanTest) {
        seconds = this.maximoHorasCalendario
      }

      if (missingHour > 0) {
        let dateAfter = new Date(startDate1.setMinutes(startDate1.getMinutes() + (6 * 60)))

        if (endDate.getTime() <= dateAfter.getTime()) {
          if (missingHour >= seconds) {
            this.hoursEdit = seconds
          } else {

            let startAddDate = startDate
            let missingDate = missingHour * 1000 * 60 * 60;
            let endAddDate = startAddDate.setTime(startAddDate.getTime() + missingDate)
            endDate = new Date(endAddDate);
            selectInfo.end = endDate
            selectInfo.endStr = this.$moment(endDate).format();;
            this.hoursEdit = missingHour
          }
          this.eventCreated = selectInfo;
          let fechaInicio = selectInfo.startStr;
          let fechaFin = selectInfo.endStr;
          let flagRangoFecha = this.ObtenerRangoFecha(fechaInicio, fechaFin, this.listCalendar);
          if (flagRangoFecha == 0) {
            this.$bvModal.show("modal-add-event");
          }
        } else {
          this.eventCreated = selectInfo;

          let seconds = (dateAfter.getTime() - startDate.getTime()) / (1000 * 60 * 60)

          this.hoursEdit = seconds
          let fechaInicio = selectInfo.startStr;

          selectInfo.endStr = this.$moment(dateAfter).format();
          let fechaFin = selectInfo.endStr
          let flagRangoFecha = this.ObtenerRangoFecha(fechaInicio, fechaFin, this.listCalendar);
          if (flagRangoFecha == 0) {
            this.$bvModal.show("modal-add-event");
          }
        }


      }


    },

    handleEvents(events) {
      
      let newEvents = events.event;
      let oldEvent = events.oldEvent;

      let fechaIniOld = oldEvent.startStr;
      let fechaFinOld = oldEvent.endStr;
      let fechaInicio = newEvents.startStr;
      let fechaFin = newEvents.endStr;

      if (this.dataStudent.flagPlanTest) {
        let dateCurrent = new Date();
        let newDateCurrent = new Date(dateCurrent.setMinutes(dateCurrent.getMinutes() - this.maximoHorasCalendario * 60))
        let dataAfter = this.$moment(newDateCurrent).add(this.daysMaxSchedule - 1, 'days')
        let dataStar = this.$moment(fechaInicio)
        let valueBefore = this.$moment(dataStar).isBefore(dataAfter);
        let valueAfter = this.$moment(new Date(fechaInicio)).isAfter(new Date());

        if (valueBefore && valueAfter) {

          let dateSelectStart = new Date(fechaInicio)
          let dateAfter = (new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60)))

          this.arraySchedulePrivate = this.arraySchedulePrivate.filter(function(e) {

            return (e.id != parseInt(oldEvent.extendedProps.idx));
          });
          this.listCalendar = this.listCalendar.filter(function(e) {

            return (e.id != parseInt(oldEvent.extendedProps.idx));
          });
          this.calendarOptions.events = this.calendarOptions.events.filter(
            function(e) {

              return (parseInt(e.id) != parseInt(oldEvent.id));
            }
          )
          events.event.remove();
          let dataTmp = this.listCalendar;
          let idx = 0;
          let ultId = dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
          ultId = ultId == null ? 0 : ultId;
          idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;
          let data2 = {
            id: idx,
            StartDate: newEvents.startStr,
            EndDate: this.$moment(dateAfter).format('YYYY-MM-DDTHH:mm:ss'),
            request: true,
            flagPlantTest: false,
          };
          this.listCalendar.push(data2);
          this.arraySchedulePrivate.push(data2);

          this.calendarOptions.events.push({
            idx: idx,
            id: createEventId(),
            start: newEvents.startStr,
            end: this.$moment(dateAfter).format('YYYY-MM-DDTHH:mm:ss'),
            title: events.event._def.title,//this.titleCourse,
            editable: true,
          });
        } else {
          this.calendarOptions.events = this.calendarOptions.events.filter(
            function(e) {
              return (parseInt(e.id) != parseInt(oldEvent.id));
            })

          events.event.remove();
          this.calendarOptions.events.push({

            id: createEventId(),
            idx: oldEvent.extendedProps.idx,
            start: oldEvent.startStr,
            end: oldEvent.endStr,
            title: events.event._def.title,//this.titleCourse,
            editable: true,
          });

        }
      } else {

        let dateSelectStart = new Date(fechaInicio)
        let dateSelectEnd = new Date(fechaFin)
        let dateSelectEndOld = new Date(fechaFinOld)
        let dateSelectStartOld = new Date(fechaIniOld)
        let dateSelectEndOld1 = new Date(fechaFinOld)
        let dateSelectStartInit2 = new Date(fechaInicio)


        let missingHour = this.hourTotal - this.editHourTotal

        let dateEnd = null
        let dateAfter = new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes() + (this.maximoHorasCalendario * 60)))
        if (missingHour > 0) {

          if ((dateSelectEnd.getTime() - dateSelectStartInit2.getTime()) == (dateSelectEndOld.getTime() - dateSelectStartOld.getTime())) {
            dateEnd = fechaFin
          } else {
            let endDate = new Date(fechaFin);
            let endDateOld = new Date(fechaFinOld)
            if (endDateOld.getTime() >= endDate.getTime()) {
              let seconds = (endDateOld.getTime() - endDate.getTime()) / (1000 * 60 * 60)
              this.editHourTotal -= seconds
              dateEnd = fechaFin
            } else {

              let dateAfterMissing = new Date(dateSelectEndOld1.setMinutes(dateSelectEndOld1.getMinutes() + missingHour * 60))


              if (dateSelectEnd.getTime() <= dateAfterMissing.getTime()) {

                if (dateSelectEnd.getTime() <= dateAfter.getTime()) {

                  let seconds = (dateSelectEnd.getTime() - dateSelectEndOld.getTime()) / (1000 * 60 * 60)
                  this.editHourTotal += seconds
                  dateEnd = fechaFin
                } else {
                  let seconds = (dateAfter.getTime() - dateSelectEndOld.getTime()) / (1000 * 60 * 60)

                  this.editHourTotal += seconds

                  dateEnd = dateAfter
                }
              } else {

                if (dateSelectEnd.getTime() <= dateAfter.getTime()) {

                  let seconds = (dateAfterMissing.getTime() - dateSelectEndOld.getTime()) / (1000 * 60 * 60)
                  this.editHourTotal += seconds
                  dateEnd = dateAfterMissing
                } else {

                  let seconds = (dateAfter.getTime() - dateSelectEndOld.getTime()) / (1000 * 60 * 60)
                  this.editHourTotal += seconds
                  dateEnd = dateAfter
                }
              }

            }

          }
        } else {

          if ((dateSelectEnd.getTime() - dateSelectStartInit2.getTime()) == (dateSelectEndOld.getTime() - dateSelectStartOld.getTime())) {
            dateEnd = fechaFin
          } else {
            let endDate = new Date(fechaFin);
            let endDateOld = new Date(fechaFinOld)

            if (endDateOld.getTime() >= endDate.getTime()) {
              let seconds = (endDateOld.getTime() - endDate.getTime()) / (1000 * 60 * 60)
              this.editHourTotal -= seconds
              dateEnd = fechaFin
            } else {
              dateEnd = fechaFinOld
            }



          }
        }

        this.arraySchedulePrivate = this.arraySchedulePrivate.filter(function(e) {
          return (e.id != parseInt(oldEvent.extendedProps.idx));
        });
        
        this.listCalendar = this.listCalendar.filter(function(e) {
          return (e.id != parseInt(oldEvent.extendedProps.idx));
        });
        
        this.calendarOptions.events = this.calendarOptions.events.filter(
          function(e) {
            return (parseInt(e.id) != parseInt(oldEvent.id));
          }
        )

        events.event.remove();

        let _eventItemMerge = ValidarMergeHorarios(this.calendarOptions.events, fechaInicio, fechaFin, this.$moment);

        if(Object.keys(_eventItemMerge ).length != 0) { //si hay merge

          this.listCalendar.forEach((obj, i) => {
            if(obj.id == (_eventItemMerge.idx == 0 ? _eventItemMerge.id : parseInt(_eventItemMerge.idx, 10)) ) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format('YYYY-MM-DDTHH:mm:ss');
              obj.EndDate = this.$moment(_eventItemMerge.end).format('YYYY-MM-DDTHH:mm:ss');
            }
          });
          this.arraySchedulePrivate.forEach((obj, i) => {
            if(obj.id == (_eventItemMerge.idx == 0 ? _eventItemMerge.id : parseInt(_eventItemMerge.idx, 10)) ) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format('YYYY-MM-DDTHH:mm:ss');
              obj.EndDate = this.$moment(_eventItemMerge.end).format('YYYY-MM-DDTHH:mm:ss');
            }
          }); 

        }else{

          let dataTmp = this.listCalendar;
          let idx = 0;
          let ultId =  dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
          ultId = ultId == null ? 0 : ultId;
          idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;

          let data2 = {
            id: idx,
            StartDate: this.$moment(newEvents.startStr).format('YYYY-MM-DDTHH:mm:ss'),
            EndDate: this.$moment(dateEnd).format('YYYY-MM-DDTHH:mm:ss'),
            request: true,
            flagPlantTest: false,
          };

          this.listCalendar.push(data2);
          this.arraySchedulePrivate.push(data2);

          this.calendarOptions.events.push({
            idx: idx,
            id: createEventId(),
            start: this.$moment(newEvents.startStr).format('YYYY-MM-DDTHH:mm:ss'),
            end: this.$moment(dateEnd).format('YYYY-MM-DDTHH:mm:ss'),
            title: events.event._def.title,//this.titleCourse,
            editable: true,
          });

        }

      }



      this.getNotSchedulecrossing();
    },


    getNotSchedulecrossing() {
      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request
      })

      let sum = 0
      arraySend.forEach(element => {

        let result = this.ObtenerRangoFechaDisable(element.StartDate, element.EndDate, this.hourPlanTest);

        sum = sum + result
      });


      if (sum == 0) {
        this.disabledDate = true;
      }
    },

    getListHours() {
      this.flagDeleteEvent = false;
      this.arraySchedulePrivate = [];
      this.disabledButtons = false;
      this.hourDisbaled = []
      this.listCalendar = [];
      this.calendarOptions.events = [];
      this.hourTotal = 0
      this.editHourTotal = 0
      this.showLoading = true;
      let json = {
        GroupScheduleProposalCustomId: this.GroupScheduleCounterProposalId,
        PersonTeacherId: this.$store.state.user.personTeacherId,
        TimeZoneName: this.$store.state.user.timeZoneName
      };


      baseInstanceAxios
        .post(_ctx + "/resources/GroupsCoursesLessons/ListScheduleTeacherByStudent", json)
        .then((response) => {

          if (response.data) {
            let typeProposalId = response.data.entity.schedule.flagTypeProposal;

            let arrayHoursTmp = response.data.entity.scheduleDetail;
            let arrayHoursConvert = convertToUserTimeCalendarEvents(arrayHoursTmp.filter((item) => {
              return (item.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST ||
                item.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE
              )
            }), this.$store.state.user.timeZoneName, this.$moment);

            let arrayHours = arrayHoursTmp.filter((item) => {
                return !(
                  item.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST ||
                  item.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE
                )
              })
              .concat(arrayHoursConvert);
            //let arrayHours = response.data.entity.scheduleDetail;

            this.SelectBeginningDate = response.data.entity.schedule.beginningDate;
            this.SelectBeginningDateInit = response.data.entity.schedule.beginningDate;
            let dataList = [];
            let id = 0
            this.hourDisbaled = arrayHours.filter((valueCurrent) => {
              return valueCurrent.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER || valueCurrent.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE
            })

            this.hourPlanTest = this.hourDisbaled.filter((valueCurrent) => {
              return valueCurrent.flagPlanTest
            })

            this.hourEnabled = arrayHours.filter((valueCurrent) => {
              return valueCurrent.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST || valueCurrent.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE
            })


            arrayHours.forEach((element) => {

              let colorResquest = "";
              let titleClass = ""
              if (Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST == element.typeOfSchedule || Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE == element.typeOfSchedule) {

                let startOfWeek = this.$moment(element.startDate).startOf('week').toDate();
                let startOfWeekCurrent = this.$moment().startOf('week').toDate();
                let diff = this.$moment(startOfWeekCurrent).diff(this.$moment(startOfWeek), 'days')
                if (diff < -7) {
                  diff = 0
                }
                this.dateStudent = this.$moment(element.startDate).add(diff, 'd')
                let dateInitData = this.$moment(element.startDate).add(diff, 'd');
                let dateEndData = this.$moment(element.endDate).add(diff, 'd')
                if (!typeProposalId) {
                  titleClass = "Class";
                  if (element.flagPlanTest) {
                    titleClass = this.$t('reusables.test-class'); //"Clase de prueba";
                  }
                  //agregar nombre del estudiante
                  titleClass = titleClass + " - " + element.className;
                } else {
                  titleClass = this.$t('reusables.teacher');
                }

                let resultCruce = this.ObtenerRangoFechaDisable(this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'), this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'), this.hourDisbaled);

                colorResquest = Constants.CALENDAR_STATUS.COMPLETED.COLOR;
                if (resultCruce != 0) {
                  colorResquest = "#cc0000"; //color clase con conflicto
                }


                this.arrayEditableSchedule.push(id)
                let startDate = new Date(element.startDate);
                let endDate = new Date(element.endDate);
                let seconds = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60)

                this.hourTotal += seconds
                this.editHourTotal += seconds

                let jsonData = {
                  id: createEventId(),
                  title: titleClass,
                  description: "",
                  idx: id,
                  start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  color: colorResquest,
                  editable: false,
                  className: resultCruce != 0 ? 'cruce' : '',
                };

                let data = {
                  id: id,
                  StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  request: element.id != 0 ? true : false,
                  flagPlantTest: element.flagPlanTest,
                  className: resultCruce != 0 ? 'cruce' : ''
                };

                dataList.push(jsonData);
                this.listCalendar.push(data);
              }
              if (Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER == element.typeOfSchedule) {

                //colorResquest = "#03c2fc";

                let className = this.lang == 'en' ? 'Class' : "Clases"
                for (let index = 0; index <= 7; index = index + 7) {

                  let dateInitData = this.$moment(new Date(element.startDate)).add(index, 'd');
                  let dateEndData = this.$moment(new Date(element.endDate)).add(index, 'd')
                  colorResquest = Constants.CALENDAR_STATUS.PENDIENT.COLOR;
                  titleClass = element.className != null ? `${className} - ${element.className}` : className
                  if (element.flagPlanTest) {
                    titleClass = this.$t('reusables.test-class'); //"Clase de prueba";
                  }

                  let jsonData = {
                    id: createEventId(),
                    title: titleClass,
                    description: "",
                    idx: id,
                    start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                    end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                    color: colorResquest,
                    editable: false,
                  };

                  let data = {
                    id: id,
                    StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                    EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                    request: element.id != 0 ? true : false,
                    flagPlantTest: element.flagPlanTest
                  };
                  dataList.push(jsonData);
                  this.listCalendar.push(data);
                }
              }
              if (Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE == element.typeOfSchedule) {
                for (let index = 0; index <= 7; index = index + 7) {

                  let dateInitData = this.$moment(new Date(element.startDate)).add(index, 'd');
                  let dateEndData = this.$moment(new Date(element.endDate)).add(index, 'd')
                  colorResquest = Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR;
                  titleClass = this.$t('reusables.unavailable')

                  let jsonData = {
                    id: createEventId(),
                    title: titleClass,
                    description: "",
                    idx: id,
                    start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                    end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                    color: colorResquest,
                    editable: false,
                  };

                  let data = {
                    id: id,
                    StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                    EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                    request: element.id != 0 ? true : false,
                    flagPlantTest: element.flagPlanTest
                  };
                  dataList.push(jsonData);
                  this.listCalendar.push(data);
                }

                //titleClass = "No disponible"
              }
              id++;
            });

            this.calendarOptions.events = dataList;

            this.calendarOptions.selectable = false;
            this.showLoading = false;
            this.disabledButtons = true;
            setTimeout(() => {
              if (arrayHours.length > 0) {

                let d = new Date(this.dateStudent);
                let startOfWeek = this.$moment(d).startOf('week').toDate();

                let month = (parseInt(new Date(startOfWeek).getMonth()) + 1) < 10 ? `0${parseInt(new Date(startOfWeek).getMonth())+1}` : parseInt(new Date(startOfWeek).getMonth()) + 1;
                let dayDate = parseInt(new Date(startOfWeek).getDate()) < 10 ? `0${parseInt(new Date(startOfWeek).getDate())}` : parseInt(parseInt(new Date(startOfWeek).getDate()));


                let calendarApi = this.$refs.fullCalendar.getApi();
                calendarApi.gotoDate(this.$moment(startOfWeek).format('YYYY') + "-" + month + "-" + dayDate);
              }
            }, 1000);

          }
        })
        .catch(err => {
          console.log("err : ", err)
        })
    },

    async getCourses() {

      await baseInstanceAxios
        .get(
          this.API_URL +
          "/resources/GroupRegisterSubjects/GetByGroupId?GroupsId=" +
          1
        )
        .then((response) => {
          if (response.data) {
            if (response.data.entity) {
              if (this.dataStudent.flagPlanTest) {
                this.titleCourse = this.$t('reusables.test-class'); //"Clase de prueba"
              } else {
                this.titleCourse = response.data.entity.subjectsName;
              }
              this.new_appointment.title = response.data.entity.subjectsName;
              if (response.data.entity.beginningDate) {
                if (this.flagState) {
                  this.SelectBeginningDate = response.data.entity.beginningDate;
                }
              }
              if (response.data.entity.subjectsName.trim().length > 0) {
                this.FlagGroupRegisterSubject = true;
              }
            }
          }
        });
    },

    // handleEventClick(clickInfo) {
    //   if (
    //     confirm(
    //       `¿Estás seguro de que quieres eliminar el evento '${clickInfo.event.title}'?`
    //     )
    //   ) {
    //     this.listCalendar = this.listCalendar.filter(function (e) {
    //       return (
    //         new Date(e.StartDate).getTime() !=
    //           new Date(clickInfo.event.startStr).getTime() &&
    //         new Date(e.EndDate).getTime() !=
    //           new Date(clickInfo.event.endStr).getTime()
    //       );
    //     });
    //     clickInfo.event.remove();
    //     this.subirHorario(false);
    //   }
    // },
    // async subirHorario(withFlag) {
    //   if (withFlag) {
    //     this.countCall = 1;
    //   }
    //   this.showSpinnerSave = true;
    //   this.showSpinner = true;
    //   let idOpcion = 1; // parseInt(this.$route.params.id);

    //   let arrayNewCalendar = [];
    //   debugger;
    //   this.listCalendar.forEach((element) => {
    //     let json = {
    //       StartDate: element.StartDate,
    //       EndDate: element.EndDate,
    //     };
    //     arrayNewCalendar.push(json);
    //   });
    //   let data = {
    //     Schedule: {
    //       Id: this.numSave,
    //       SchedulesOptionsId: idOpcion,
    //       GroupsId: 1,
    //       Flag: withFlag ? true : this.flagState,
    //       BeginningDate: this.SelectBeginningDate,
    //       Status: withFlag ? true : this.flagState,
    //     },
    //     ScheduleDetail: arrayNewCalendar,
    //     UserMail : this.$store.state.user.email
    //   };

    //   var api_url = _ctx + `/resources/GroupsCoursesLessons/SaveSchedule`;
    //   await baseInstanceAxios({
    //     method: "POST",
    //     url: api_url,
    //     data: data,
    //   })
    //     .then(() => {
    //       this.$bvModal.hide("modal-notes");
    //       this.getListHoursCalendar();
    //       if (withFlag) {
    //         this.message = `Se ${
    //           this.numSave == 0 ? "guardó" : "actualizó"
    //         } correctamente su horario`;
    //         this.$bvToast.show("toast-check-calendar");
    //       }
    //       this.showSpinner = false;
    //       this.showSpinnerSave = false;
    //     })
    //     .catch(function (error) {
    //       this.message = `Hubo un error al registar el horario.`;
    //       this.$bvToast.show("toast-equis-calendar");
    //       this.showSpinner = false;
    //       this.showSpinnerSave = false;
    //     });
    // },

    ObtenerDuracion(fecha1, fecha2) {
      let minute = fecha2.diff(fecha1, "minutes");
      let minuteMod = (minute / 60) % 1;
      return minuteMod;
    },

    ObtenerRangoFecha(StartDate, EndDate, listCalendar) {

      var result = listCalendar.filter((e) => {

        return (
          (!(
              new Date(StartDate).getTime() == new Date(e.StartDate).getTime()
            ) &&
            new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.EndDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime())
        );
      });
      return result.length;
    },

    ObtenerRangoFechaDisable(StartDate, EndDate, listCalendar) {

      var result = listCalendar.filter((e) => {
        if ((!(
              new Date(StartDate).getTime() == new Date(e.startDate).getTime()
            ) &&
            new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.endDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime())) {
          if (!this.dataStudent.flagPlanTest) {
            if (e.flagPlanTest) {

              this.disabledDate = false;
              let num = 7
              this.minDate = new Date(e.startDate)
              this.minDate.setDate(this.minDate.getDate() + 1)
              let d = new Date(e.startDate),
                diff = d.getDate() + num
              this.maxDate = new Date(d.setDate(diff))


            }
          }

        }


        return (
          (!(
              new Date(StartDate).getTime() == new Date(e.startDate).getTime()
            ) &&
            new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.endDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime())
        );
      });
      return result.length;
    },
    getCalendarHeaderToolbarTestClass(flagShowHeader){
      if(flagShowHeader){
          return {
              left: "",
              center:  'title',
              right:'',
          }
      }

      return {
          left: "",
          center:  '',
          right:'',
      }
    },
    showTeacherInfoComment(id) {

      this.$emit('listenTeacherInfoComments', id);
    },
    async validateCounterProposal(groupScheduleCounterProposalId) {
      let flagContinue = false;
      let flagType = false; //parametro para validar la solicitud y no la propuesta o contrapropuesta
      let params = {
        groupScheduleCounterProposalId,
        flagType
      };

      await baseInstanceAxios
        .get(`${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateCounterProposalStudentByActive`, {
          params
        })
        .then((response) => {
          flagContinue = response.data.return;
          if (!response.data.return) {
            let entity = response.data.entity;

            if (entity.flagProposalAcepted) {
              this.messageValidate = this.$t("reusables.student-edited-schedule-11"); //GH => Cambiar
              this.typeResponseEvent = 1;
            } else {
              let objectStatus = Constants.STATUS_VALIDATION_COUNTER_PROPOSAL[entity.typeResult];
              if (objectStatus)
                this.messageValidate = this.lang == 'es' ? objectStatus.ES : objectStatus.EN;

              if (entity.flagCount) {
                if (this.typeOption == 1) {
                  this.typeResponseEvent = (entity.countProposalMassive == 0) ? 2 : 3;
                } else {
                  this.typeResponseEvent = (entity.countProposalDirects == 0) ? 4 : 3;
                }
              } else {
                this.typeResponseEvent = 1;
              }
            }
            this.$bvModal.show("modal-conflict-validate");
          }
        });
      return flagContinue;
    }
  }
}
</script>

<style>
  .icon-yout-disabled{
    fill: #b7b8bd !important;
    pointer-events: none !important;
  }
</style>